import type React from 'react';
import { createPortal } from 'react-dom';

import { OnboardingProgressBar } from '@cobliteam/onboarding';

interface PortalProviderProps {
  children: React.ReactNode;
}

const PortalProvider = ({ children }: PortalProviderProps) => {
  const progressContentEl = document.getElementById('onboarding-progress-bar');
  return (
    <>
      {children}
      {progressContentEl && createPortal(<OnboardingProgressBar />, progressContentEl)}
    </>
  );
};

export default PortalProvider;
